
import { defineComponent, reactive, onMounted, onBeforeUnmount } from "vue";

// Background images
interface BackgroundProperties {
  readonly fileName: string; // Background image filename
  readonly position: string; // Background position properties
  isShown: boolean; // Toggle to show this background
}
const backgroundProperties = reactive<BackgroundProperties[]>([
  {
    fileName: "./image/top_1.jpg",
    position: "left 40% bottom 30%",
    isShown: false
  },
  {
    fileName: "./image/top_2.jpg",
    position: "center bottom 10%",
    isShown: false
  },
  {
    fileName: "./image/top_3.jpg",
    position: "center bottom 15%",
    isShown: false
  },
  {
    fileName: "./image/top_4.jpg",
    position: "center bottom 10%",
    isShown: false
  },
  {
    fileName: "./image/top_5.jpg",
    position: "center bottom 15%",
    isShown: false
  }
]);

// State parameter
interface StateParameters {
  updateIntervalTimer: number | undefined;
  currentIndex: number;
}

// Component definition
export default defineComponent({
  name: "HomeBackground",
  props: {
    changeInterval: {
      type: Number,
      default: 8000
    }
  },
  setup(props) {
    const state: StateParameters = {
      updateIntervalTimer: 0,
      currentIndex: 0
    };

    const slide = () => {
      const nextIndex =
        state.currentIndex >= backgroundProperties.length - 1
          ? 0
          : state.currentIndex + 1;
      backgroundProperties[state.currentIndex].isShown = false;
      backgroundProperties[nextIndex].isShown = true;
      state.currentIndex = nextIndex;
    };

    onMounted(async () => {
      window.setTimeout(() => {
        backgroundProperties[0].isShown = true;
        window.setTimeout(() => {
          state.updateIntervalTimer = window.setInterval(
            slide,
            props.changeInterval
          );
        }, 2000);
      }, 100);
    });
    onBeforeUnmount(() => {
      clearInterval(state.updateIntervalTimer);
      backgroundProperties[state.currentIndex].isShown = false;
      state.currentIndex = 0;
    });
    return {
      backgroundProperties
    };
  }
});
